import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import Navbar from "../../components/Navbar";
import axios from "axios";
import Axios from "../../utils/Axios";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import CircularProgress from "@mui/material/CircularProgress";
import toast, { Toaster } from "react-hot-toast";
// import "./UniversityEvents.css";

Modal.setAppElement("#root");

const Coupons = () => {
  const [coupons, setCoupons] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedCouponId, setSelectedCouponId] = useState(null);
  const [isLoadingCoupons, setIsLoadingCoupons] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [couponData, setCouponData] = useState({
    code: "",
    valid_from: "",
    valid_to: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchCoupons();
  }, []);

  const fetchCoupons = async () => {
    setIsLoadingCoupons(true);
    try {
      const res = await axios.post(Axios.axiosUrl + Axios.getAllCoupons);
      setCoupons(res.data);
    } catch (err) {
    } finally {
      setIsLoadingCoupons(false);
    }
  };

  const openModal = () => {
    setModalIsOpen(true);
    setEditMode(false);
    setCouponData({ code: "", valid_from: "", valid_to: "" });
    setErrors({});
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setEditMode(false);
    setSelectedCouponId(null);
    setErrors({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCouponData({ ...couponData, [name]: value });
    if (errors[name]) setErrors({ ...errors, [name]: "" });
  };

  const validate = () => {
    const newErrors = {};
    if (!couponData.code.trim()) newErrors.code = "Coupon code is required";
    if (!couponData.valid_from) newErrors.valid_from = "Valid From is required";
    if (!couponData.valid_to) newErrors.valid_to = "Valid To is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const saveCoupon = async () => {
    if (!validate()) return;
    setIsSubmitting(true);
    await axios
      .post(Axios.axiosUrl + Axios.createCoupon, {
        COUPON_CODE: couponData.code,
        VALID_FROM: couponData.valid_from,
        VALID_TO: couponData.valid_to,
      })
      .then((response) => {
        if (response.data.overlappingActiveCouponError == true) {
          toast.error("Coupon already exists");
        } else {
          toast.success("Coupon created successfully");
          closeModal();
          fetchCoupons();
        }
        console.log("asdkasdasdas", response.data);
      })
      .catch((err) => {
        console.log("asdkasdasdas", err);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const updateCoupon = async () => {
    if (!validate()) return;
    setIsSubmitting(true);
    try {
      const response = await axios.post(Axios.axiosUrl + Axios.updateCoupon, {
        ID: selectedCouponId,
        COUPON_CODE: couponData.code,
        VALID_FROM: couponData.valid_from,
        VALID_TO: couponData.valid_to,
      });
      if (response.data.overlappingActiveCouponError == true) {
        toast.error("Coupon already exists");
      } else {
        toast.success("Coupon updated successfully");
        fetchCoupons();
        closeModal();
      }
    } catch (err) {
      toast.error("Failed to update coupon");
    } finally {
      setIsSubmitting(false);
    }
  };

  const confirmDeleteCoupon = async () => {
    try {
      await axios.post(Axios.axiosUrl + Axios.deleteCoupon, {
        ID: selectedCouponId,
      });
      toast.success("Coupon deleted successfully");
      setDeleteModalOpen(false);
      fetchCoupons();
    } catch (err) {
      toast.error("Failed to delete coupon");
    }
  };

  return (
    <div>
      <Navbar />
      <Toaster />
      <div style={{ padding: "2rem" }}>
        <h2 style={{ color: "#009D7C" }}>Coupons</h2>
        <button onClick={openModal} className="add-btn">
          Add Coupon
        </button>

        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Coupon Code</th>
                <th>Valid From</th>
                <th>Valid To</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoadingCoupons ? (
                <tr>
                  <td
                    colSpan="4"
                    style={{ textAlign: "center", padding: "2rem" }}
                  >
                    <CircularProgress />
                  </td>
                </tr>
              ) : coupons.length === 0 ? (
                <tr>
                  <td
                    colSpan="4"
                    style={{ textAlign: "center", padding: "2rem" }}
                  >
                    No coupons found.
                  </td>
                </tr>
              ) : (
                coupons.map((coupon) => (
                  <tr key={coupon.ID}>
                    <td>{coupon.COUPON_CODE}</td>
                    <td>{new Date(coupon.VALID_FROM).toDateString()}</td>
                    <td>{new Date(coupon.VALID_TO).toDateString()}</td>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        <span
                          style={{
                            backgroundColor: "#1976d2",
                            padding: 5,
                            borderRadius: 50,
                            marginRight: 10,
                          }}
                        >
                          <EditIcon
                            fontSize="10"
                            sx={{ cursor: "pointer", color: "#fff" }}
                            onClick={() => {
                              setEditMode(true);
                              setSelectedCouponId(coupon.ID);
                              setCouponData({
                                code: coupon.COUPON_CODE,
                                valid_from: coupon.VALID_FROM.split("T")[0],
                                valid_to: coupon.VALID_TO.split("T")[0],
                              });
                              setModalIsOpen(true);
                            }}
                          />
                        </span>
                        <span
                          style={{
                            backgroundColor: "red",
                            padding: 5,
                            borderRadius: 50,
                          }}
                        >
                          <DeleteIcon
                            fontSize="10"
                            sx={{ cursor: "pointer", color: "#fff" }}
                            onClick={() => {
                              setSelectedCouponId(coupon.ID);
                              setDeleteModalOpen(true);
                            }}
                          />
                        </span>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Modal for Create / Update */}
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={{
            content: {
              maxWidth: "500px",
              margin: "auto",
              padding: "20px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              maxHeight: "45vh",
              zIndex: 9999,
            },
            overlay: {
              zIndex: 9998,
              backgroundColor: "rgba(0,0,0,0.5)",
            },
          }}
        >
          <h3>{editMode ? "Update Coupon" : "Add Coupon"}</h3>
          <div className="modal-body">
            <label className="title-label">Coupon</label>

            <input
              name="code"
              placeholder="Coupon Code"
              value={couponData.code}
              onChange={handleChange}
              className="input"
            />
            {errors.code && <span className="error-msg">{errors.code}</span>}

            <label className="title-label">Valid From</label>
            <input
              type="date"
              name="valid_from"
              value={couponData.valid_from}
              onChange={handleChange}
              className="input"
            />
            {errors.valid_from && (
              <span className="error-msg">{errors.valid_from}</span>
            )}

            <label className="title-label">Valid To</label>
            <input
              type="date"
              name="valid_to"
              value={couponData.valid_to}
              onChange={handleChange}
              className="input"
            />
            {errors.valid_to && (
              <span className="error-msg">{errors.valid_to}</span>
            )}
          </div>
          <div className="modal-footer">
            <button
              onClick={editMode ? updateCoupon : saveCoupon}
              className="save-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <CircularProgress size={20} />
              ) : editMode ? (
                "Update"
              ) : (
                "Save"
              )}
            </button>
            <button onClick={closeModal} className="cancel-btn">
              Cancel
            </button>
          </div>
        </Modal>

        {/* Delete Confirmation */}
        <Modal
          isOpen={deleteModalOpen}
          onRequestClose={() => setDeleteModalOpen(false)}
          style={{
            content: {
              maxWidth: "500px",
              margin: "auto",
              padding: "20px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              maxHeight: "15vh",
              zIndex: 9999,
            },
            overlay: {
              zIndex: 9998,
              backgroundColor: "rgba(0,0,0,0.5)",
            },
          }}
        >
          <h3>Are you sure you want to delete this coupon?</h3>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "1rem",
              marginTop: "1.5rem",
            }}
          >
            <button onClick={confirmDeleteCoupon} className="delete-btn">
              Delete
            </button>
            <button
              onClick={() => setDeleteModalOpen(false)}
              className="cancel-btn"
            >
              Cancel
            </button>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default Coupons;
